import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    InputSignal,
    model,
    ModelSignal,
    Signal,
} from '@angular/core';

import { RessourcesModule } from '@ressources/client/ressources.module';

type ExpansionPanelContentStyle = { maxHeight: string; overflow: string; padding: string };
const defaultContentStyle: ExpansionPanelContentStyle = { maxHeight: '0', overflow: 'hidden', padding: '0' };
const expandedContentStyle: ExpansionPanelContentStyle = {
    maxHeight: `fit-content`,
    overflow: 'visible',
    padding: '0',
};

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-expansion-panel',
    styleUrl: './expansion-panel.component.scss',
    templateUrl: './expansion-panel.component.html',
})
export class ExpansionPanelComponent {
    public readonly chevronColor: InputSignal<string> = input<string>('black');
    public readonly contentStyle: Signal<ExpansionPanelContentStyle> = computed<ExpansionPanelContentStyle>(() =>
        this.isExpanded() ? expandedContentStyle : defaultContentStyle,
    );
    public readonly disabled: InputSignal<boolean> = input<boolean>(false);
    public readonly isExpanded: ModelSignal<boolean> = model<boolean>(false);

    public toggleExpansion(): void {
        if (this.disabled()) {
            return;
        }

        this.isExpanded.set(!this.isExpanded());
    }
}
